import { Controller } from "@hotwired/stimulus"

// #588 — floating AI customer-service widget.
// Toggles the chat panel, keeps the message list scrolled to the newest content
// (including while answers stream in over Turbo Streams), and clears + refocuses
// the input after each send.
export default class extends Controller {
    static targets = ["panel", "messages", "input", "frame"]
    static values = { frameUrl: String }

    toggle() {
        this.panelTarget.classList.toggle("hidden")
        if (!this.panelTarget.classList.contains("hidden")) {
            this.loadFrame()
            this.scrollToBottom()
            this.focusInput()
        }
    }

    // Load the chat panel on first open. A lazy turbo-frame inside a
    // display:none container does not reliably fire its own load, so set the
    // src explicitly the first time the widget is opened.
    loadFrame() {
        if (this.hasFrameTarget && !this.frameTarget.getAttribute("src")) {
            this.frameTarget.setAttribute("src", this.frameUrlValue)
        }
    }

    close() {
        this.panelTarget.classList.add("hidden")
    }

    // The messages list lives inside the lazily-loaded frame, so wire the
    // auto-scroll observer once the target actually connects.
    messagesTargetConnected(element) {
        this.observer = new MutationObserver(() => this.scrollToBottom())
        this.observer.observe(element, { childList: true, subtree: true, characterData: true })
        this.scrollToBottom()
    }

    messagesTargetDisconnected() {
        if (this.observer) {
            this.observer.disconnect()
            this.observer = null
        }
    }

    reset(event) {
        const form = event.target
        if (form && typeof form.reset === "function") form.reset()
        this.focusInput()
        this.scrollToBottom()
    }

    scrollToBottom() {
        if (this.hasMessagesTarget) {
            this.messagesTarget.scrollTop = this.messagesTarget.scrollHeight
        }
    }

    focusInput() {
        if (this.hasInputTarget) this.inputTarget.focus()
    }
}
